import React from 'react';
import { PiletApi } from '@sharefiledev/sharefile-appshell';
import { Modal, theme } from 'antd';
import { t } from '../../utils';
import { CreateDocumentTemplateModalBody } from './CreateDocumentTemplateModalBody';

type CreateDocumentTemplateModalProps = {
	app: PiletApi;
	onClose: () => void;
};

export const CreateDocumentTemplateModal: React.FC<CreateDocumentTemplateModalProps> = ({
	app,
	onClose,
}) => {
	const { token } = theme.useToken();
	return (
		<Modal
			open
			title={t('createDocumentTemplateModal.title')}
			onCancel={onClose}
			okButtonProps={{ style: { display: 'none' } }}
			centered
			width={680}
			styles={{
				body: {
					marginTop: token.marginMD,
					marginBottom: token.marginLG,
				},
			}}
		>
			<CreateDocumentTemplateModalBody app={app} onClose={onClose} />
		</Modal>
	);
};
